import { render, staticRenderFns } from "./PrepProcessCard.vue?vue&type=template&id=45afd4a1&v-if=prep_process.id"
import script from "./PrepProcessCard.vue?vue&type=script&lang=js"
export * from "./PrepProcessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports